module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (245).648637a1.jpg";